import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { IoChevronBack, IoChevronDown, IoChevronForward, IoFilter, IoPlaySkipBack, IoPlaySkipForward } from 'react-icons/io5';
import { FaCheck, FaExclamation } from 'react-icons/fa6';

import { IOcorrencia, IRelatorioAnaliticoRondaBody, IRonda } from '../../../@interfaces/rondas';

import OcorrenciasModal from './ocorrenciasModal';
import RelatoriosFiltrosModal from './filtros';
import { SelectOptions } from '../../../@types';
import ApiGeral from '../../../services/ApiGeral';
import { CustumerContext } from '../../../contexts/custumer';
import APIRelatorios from '../../../services/APIRelatorios';
import moment from 'moment';
import ToastContext from '../../../contexts/toast';
import { resolve } from 'dns';
import MensagemListaVazia from '../../../components/mensagemlistavazia';
import RelatorioSkeleton from './skeleton';


export interface IFiltros {
  empresaCliente: string | number | null;
  local: string | number | null;
  situacaoRonda: string[];
  areaSupervisao: string | number | null;
  turno: string | number | null;
  empresaFuncionario: string | number | null;
  funcionario: string | number | null;
  possuiOcorrencia: boolean;
}



export const initialFiltros: IFiltros = {
  empresaCliente: null,
  local: null,
  situacaoRonda: [],
  areaSupervisao: null,
  turno: null,
  empresaFuncionario: null,
  funcionario: null,
  possuiOcorrencia: false,
};


function situacaoColor(situacao: string) {
  const map: Record<string, string> = {
    REALIZADO: 'bg-green-100 text-green-700',
    'Falha Comunicação': 'bg-red-100 text-red-700',
    PERDIDA: 'bg-red-100 text-red-700',
    INTERROMPIDA: 'bg-orange-100 text-orange-700',
    'Estourou o tempo': 'bg-yellow-100 text-yellow-700',
  };

  return map[situacao.toUpperCase()] ?? 'bg-gray-100 text-gray-700';
}


function formatarHora(data: string){
  return moment.utc(data).format('HH:mm');
}


function formatarData(data: string){
  return moment.utc(data).format('DD/MM/YYYY');
}


function horarioValido(valor?: string | null): boolean {
  if (!valor) return false;
  if (valor.startsWith('1899-12-30')) return false;

  return moment.utc(valor).isValid();
}



const EXECUCOES_POR_PAGINA = 10;

export interface IVisualizacaoOcorrencia {
  titulo: string
  ocorrencias: IOcorrencia[]
}

const RelatorioAnaliticoRonda: React.FC = () => {
  const [dateInit, setDateInit] = useState('');
  const [dateFin, setDateFin] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState<IRonda[] | null>(null);
  const [ocorrenciasAMostrar, setOcorrenciasAMostrar] = useState<IVisualizacaoOcorrencia | null>(null);
  const [filtrosAbertos, setFiltrosAbertos] = useState(false);
  const [opcoesLocal, setOpcoesLocal] = useState<SelectOptions[]>([]);
  const [opcoesEmpresa, setOpcoesEmpresa] = useState<SelectOptions[]>([]);
  const [opcoesTurno, setOpcoesTurno] = useState<SelectOptions[]>([]);
  const [situacoesRonda, setSituacoesRonda] = useState<SelectOptions[]>([]);
  const [filtros, setFiltros] = useState<IFiltros>(initialFiltros);

  const [pagina, setPagina] = useState(0);
  const paginas = useMemo(() => (resultado ? paginarRondas(resultado) : []), [resultado]);

  const { showErrorToast } = useContext(ToastContext);

  const { id_current_custumer }= useContext(CustumerContext)



  
  const topoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    topoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [pagina]);


  useEffect(() => {
    carregarLocais();
    carregarEmpresas();
    carregarTurnos();
    carregarSituacoes();
  }, [])




  

  async function carregarLocais() {
    try {
      if (!id_current_custumer) return;

      setOpcoesLocal([]);

      const response = await ApiGeral.getPlacesList({ cliente: id_current_custumer, SomentePontoEletronico: false });

      if (!response.error && response.local) {
        setOpcoesLocal(response.local.map(l => ({
          label: l.descricao,
          value: l.local
        })));
      }
    } catch (error) {
      throw new Error(`getLocais: ${error}`);
    }
  }


  


  async function carregarEmpresas() {
    try {
      const response = await ApiGeral.getCompanies();

      if (!response.error && response.empresas) {
        setOpcoesEmpresa(response.empresas.map(e => ({
          label: e.nomeEmpresa ?? e.nome ?? '',
          value: e.empresa
        })));
      }
    } catch (error) {
      throw new Error(`getEmpresas: ${error}`);
    }
  }



  async function carregarTurnos() {
    try {
      const response = await ApiGeral.getTurnos();
      if (!response.error && response.turnos) {
        setOpcoesTurno(response.turnos.map(t => ({
          label: t.descricao,
          value: t.turno
        })));
      }
    } catch (error) {
      throw new Error(`getTurnos: ${error}`);
    }
  }


  async function carregarSituacoes() {
    try {
      const response = await APIRelatorios.getSituacoesRonda();
      if (!response.error && response.situacoesRonda) {
        setSituacoesRonda(response.situacoesRonda.map(t => ({
          label: t.descricao,
          value: t.situacaoRonda
        })));
      }
    } catch (error) {
      throw new Error(`getTurnos: ${error}`);
    }
  }



  async function carregarRelatorio(filtros: IFiltros) {
    try {

      if(!dateInit) return showErrorToast("Selecione a data inicial");
      if(!dateFin) return showErrorToast("Selecione a data final");

      setLoading(true);
      setResultado(null);

      const body: IRelatorioAnaliticoRondaBody = {
        dataInicio: moment(dateInit).format('YYYYMMDD'),
        dataFim: moment(dateFin).format('YYYYMMDD'),
        cliente: id_current_custumer,
        empresaCliente: filtros.empresaCliente ? Number(filtros.empresaCliente) : undefined,
        local: filtros.local ? Number(filtros.local) : undefined,
        situacaoRonda: filtros.situacaoRonda.length > 0 ? filtros.situacaoRonda.map(Number) : undefined,
        areaSupervisao: filtros.areaSupervisao ? Number(filtros.areaSupervisao) : undefined,
        turno: filtros.turno ? Number(filtros.turno) : undefined,
        empresaFuncionario: filtros.empresaFuncionario ? Number(filtros.empresaFuncionario) : undefined,
        funcionario: filtros.funcionario ? Number(filtros.funcionario) : undefined,
        possuiOcorrencia: filtros.possuiOcorrencia ? 1 : undefined,
      }

      const response = await APIRelatorios.getRelatorioAnaliticoRonda(body);

      if(response.error) return showErrorToast(response.message);
      if(response.rondas!.length === 0) return showErrorToast("Nenhuma ronda encontrada com esses parãmetros.")

      setResultado(response.rondas!);
      setPagina(0);



    } catch (error) {
      throw new Error(`getRelatorioAnaliticoRonda: ${error}`);
    }finally{
      setLoading(false);
    }
  }


  async function abrirFiltros(){
    if(!dateInit) return showErrorToast("Selecione a data inicial");
    if(!dateFin) return showErrorToast("Selecione a data final");


    setFiltrosAbertos(true);
  }




  function paginarRondas(rondas: IRonda[], porPagina = EXECUCOES_POR_PAGINA): IRonda[][] {
    const paginas: IRonda[][] = [];
    let paginaAtual: IRonda[] = [];
    let restante = porPagina;

    for (const ronda of rondas) {
      if (ronda.execucoes.length === 0) {
        paginaAtual.push(ronda);
        continue;
      }

      let execucoes = ronda.execucoes;

      while (execucoes.length > 0) {
        const fatia = execucoes.slice(0, restante);
        execucoes = execucoes.slice(fatia.length);

        paginaAtual.push({ ...ronda, execucoes: fatia });
        restante -= fatia.length;

        if (restante === 0) {
          paginas.push(paginaAtual);
          paginaAtual = [];
          restante = porPagina;
        }
      }
    }

    if (paginaAtual.length > 0) paginas.push(paginaAtual);

    return paginas;
  }

  const qtdFiltrosAplicados = useMemo(() => {
    return Object.values(filtros).filter((value) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return Boolean(value);
    }).length;
  }, [filtrosAbertos]);




  return (
    <div ref={topoRef}>
      <div className="flex flex-wrap items-stretch gap-6 mt-4">
        <div className="flex items-center gap-2 max-[1215px]:items-start max-[750px]:flex-row max-[750px]:items-center max-[615px]:!flex-col max-[615px]:!items-start max-[615px]:!w-full">
          <span className="text-black/40 text-[.875rem] font-medium">
            Período
          </span>

          <div className="flex gap-4 items-center max-[615px]:w-full">
            <div className="relative max-[615px]:w-full">
              <input
                type="date"
                value={dateInit}
                onChange={(e) => setDateInit(e.target.value)}
                max={dateFin}
                className="appearance-none border-none rounded-lg bg-white px-[15px] py-[7px] w-[145px] h-[32.8px] shadow-[0_7px_29px_0_rgba(100,100,111,0.2)] outline-none text-black/50 [&::-webkit-date-and-time-value]:text-left max-[615px]:w-full"
              />

              
            </div>

            -

            <div className="relative max-[615px]:w-full">
              <input
                type="date"
                value={dateFin}
                onChange={(e) => setDateFin(e.target.value)}
                min={dateInit}
                max="9999-12-31"
                className="appearance-none border-none rounded-lg bg-white px-[15px] py-[7px] w-[145px] h-[32.8px] shadow-[0_7px_29px_0_rgba(100,100,111,0.2)] outline-none text-black/50 [&::-webkit-date-and-time-value]:text-left max-[615px]:w-full"
              />

            </div>
          </div>
        </div>

        <button
          onClick={() => carregarRelatorio(filtros)}
          disabled={loading}
          className="bg-primary border-none px-2 py-[7px] w-[100px]  rounded text-white flex justify-center items-center text-xs cursor-pointer transition-all duration-300"
        >
          {loading ? 'Buscando...' : 'Buscar'}
        </button>

        <button
          onClick={abrirFiltros}
          className="relative flex items-center justify-center bg-transparent border-none cursor-pointer h-[32.8px] ml-auto"
        >
          <IoFilter size={16} className="text-black/50" />

          {qtdFiltrosAplicados > 0 && (
            <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 rounded-full bg-primary text-white text-[10px] font-medium">
              {qtdFiltrosAplicados}
            </span>
          )}
        </button>
      </div>
      {loading && <RelatorioSkeleton />}

      {resultado && (
        <div className="flex flex-col gap-6 mt-8">
          {paginas[pagina]?.map((ronda, i) => (
            <div
              key={i}
              className="border border-solid border-gray-200 rounded-lg overflow-hidden"
            >
              <div className="bg-contrast px-4 py-3 flex flex-wrap gap-x-8 gap-y-1">
                <div>
                  <span className="text-black/40 text-xs block">Ronda</span>
                  <span className="text-sm font-medium">
                    {ronda.nome}
                  </span>
                </div>

                <div>
                  <span className="text-black/40 text-xs block">
                    Empresa
                  </span>
                  <span className="text-sm font-medium">
                    {ronda.empresa}
                  </span>
                </div>

                <div>
                  <span className="text-black/40 text-xs block">
                    Cliente
                  </span>
                  <span className="text-sm font-medium">
                    {ronda.cliente.nomeCliente}
                  </span>
                </div>

                <div>
                  <span className="text-black/40 text-xs block">
                    Local
                  </span>
                  <span className="text-sm font-medium">
                    {ronda.local.nomeLocal}
                  </span>
                </div>
              </div>

              <div className="divide-y divide-solid divide-gray-100">
                {ronda.execucoes.map((exec, j) => (
                  <div
                    key={j}
                    className="px-4 py-4 bg-white border-t border-solid border-gray-200 flex flex-col gap-2"
                  >
                    <div className="flex flex-col gap-1 lg:flex-row lg:flex-wrap lg:items-center lg:gap-x-6 lg:gap-y-1">
                      <div className="flex items-center justify-between gap-4 lg:contents">
                        <span className="text-base font-medium">{formatarHora(exec.horarioProgramado)}</span>

                        <div className="flex items-center gap-3 lg:ml-auto lg:order-last">
                          {exec.ocorrencias.length > 0 && (
                            <button
                              onClick={() => setOcorrenciasAMostrar({ titulo:formatarHora(exec.horarioProgramado), ocorrencias: exec.ocorrencias})}
                              className="text-xs text-primary font-semibold bg-transparent border-none cursor-pointer"
                            >
                              Ver ocorrência
                            </button>
                          )}
                          <span className={`text-xs px-2 py-0.5 rounded-full ${situacaoColor(exec.situacao)}`}>
                            {exec.situacao}
                          </span>
                        </div>
                      </div>

                      <span className="text-xs lg:text-sm  text-black/50">{formatarData(exec.data)} • {exec.turno}</span>
                      {(horarioValido(exec.horarioInicio) && horarioValido(exec.horarioFim)) && <span className="text-xs lg:text-sm text-black/50">Início {formatarHora(exec.horarioInicio)} - Fim {formatarHora(exec.horarioFim)}</span>}
                      {exec.colaborador !== null && <span className="text-xs lg:text-sm text-black/50">{exec.colaborador.nome} (RE {exec.colaborador.rE})</span>}
                    </div>

                    {exec.pontos.length> 0 && <div className="flex flex-col gap-1">
                      {exec.pontos.map((ponto, k) => (
                        <div
                          key={k}
                          onClick={() =>
                            setOcorrenciasAMostrar({titulo: ponto.nome, ocorrencias: ponto.ocorrencias})
                          }
                          className="flex items-center gap-4 w-full py-2 text-sm text-black/60 border-l-2 px-2 border-solid border-gray-300 cursor-pointer transition-colors duration-300 hover:bg-gray-100"
                        >
                          <span className="font-medium text-black/80">
                            {ponto.nome}
                          </span>

                          <span>
                          {horarioValido(ponto.marcacao) ?   `Marcado às ${formatarHora(ponto.marcacao)}` : "Sem marcação"}
                          </span>

                          {ponto.ocorrencias.length === 0 ? (
                            <FaCheck
                              size={16}
                              className="text-green-600 ml-auto"
                            />
                          ) : (
                            <FaExclamation
                              size={16}
                              className="text-red-400 ml-auto"
                            />
                          )}
                        </div>
                      ))}
                    </div>}
                  </div>
                ))}
              </div>
            </div>
          ))}
          {paginas.length > 1 && (
            <div className="flex items-center justify-center gap-4 mt-6">

              <button
                disabled={pagina === 0}
                onClick={() => setPagina(0)}
                className="flex items-center justify-center bg-transparent border-none cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <IoPlaySkipBack size={18} className="text-black/60" />
              </button>
              <button
                disabled={pagina === 0}
                onClick={() => setPagina(p => p - 1)}
                className="flex items-center justify-center bg-transparent border-none cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <IoChevronBack size={18} className="text-black/60" />
              </button>

              <span className="text-sm text-black/60">
                {pagina + 1} de {paginas.length}
              </span>

              <button
                disabled={pagina === paginas.length - 1}
                onClick={() => setPagina(p => p + 1)}
                className="flex items-center justify-center bg-transparent border-none cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <IoChevronForward size={18} className="text-black/60" />
              </button>

              <button
                disabled={pagina === paginas.length - 1}
                onClick={() => setPagina(paginas.length - 1)}
                className="flex items-center justify-center bg-transparent border-none cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <IoPlaySkipForward size={18} className="text-black/60" />
              </button>
            </div>
          )}
        </div>
      )}

      {!resultado && !loading && <MensagemListaVazia className="!mt-10" texto='Nenhuma ronda encontrada' />}

      {ocorrenciasAMostrar !== null && (
        <OcorrenciasModal
          titulo={ocorrenciasAMostrar.titulo}
          ocorrencias={ocorrenciasAMostrar.ocorrencias}
          closeModal={() => setOcorrenciasAMostrar(null)}
        />
      )}

      {filtrosAbertos && (
        <RelatoriosFiltrosModal
          handleClose={() => setFiltrosAbertos(false)}
          onApply={(novosFiltros) => {
            setFiltros(novosFiltros);
            carregarRelatorio(novosFiltros);
            setFiltrosAbertos(false);
          }}
          filtros={filtros}
          opcoesEmpresa={opcoesEmpresa}
          opcoesLocal={opcoesLocal}
          opcoesTurno={opcoesTurno}
          opcoesSituacao={situacoesRonda}
          dateInit={dateInit}
          dateFin={dateFin}
        />
      )}
    </div>
  );
};

export default RelatorioAnaliticoRonda;

